import { standardAccountNumberFormat } from "../../../../../utils/standardAccountNumberFormat";
import CardActionableButton from "../../../CommonViewAllCard/CardSubComponent/CardActionableButton";
import FormatAmount from "../../../FormatAmount/FormatAmount";
import TickerAnimation from "../../../TickerAnimation";
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef IconComponent
 * @type {object}
 * @property {String} icon - Icon to show
 * @property {String} bgColor - Background color of icon var only
 * @property {String} [title] - Text to show on hover
 * @property {Boolean} isDisabled
 * @property {String} props.imgColor - Color for icon if needed (var Only)
 * @property {OnClickEventHandler} [onClick] - If this is not undefined, this button will be made actionable.
 *
 */
/**
 * @typedef {("normal" | "semibold")} fontWeight
 * @typedef {("AccountNumber" | "Amount" | "Text")} type
 * @typedef {("lowercase" | "uppercase" | "capitalize")} textCase
 * @param {Object} props
 * @param {String} props.text - Header text
 * @param {IconComponent[]} props.iconComponentArray - Array of what icons to show
 *
 * @returns {JSX.Element}
 */
const ListTextWithIcon = ({ text, iconComponentArray, type }) => {
  const shouldBeRedacted = (price) => {
    return (
      price === "xxxx.xx" ||
      isNaN(+price) ||
      price === null ||
      price === undefined
    );
  };
  return (
    <div className="w-full p-padding-sm flex justify-between items-center relative">
      <p
        className={`text-font-xs text-text-primary flex-1 truncate font-normal`}
      >
        {type === "Amount" ? (
          <>
            {shouldBeRedacted(text) ? "" : "INR"}{" "}
            <FormatAmount price={Number(text)} />
          </>
        ) : type === "AccountNumber" ? (
          standardAccountNumberFormat(text)
        ) : (
          <TickerAnimation text={text} />
        )}
      </p>
      <div
        className="gap-x-gap-sm ml-margin-sm justify-end"
        style={{
          display: iconComponentArray?.length ? "flex" : "none",
        }}
      >
        {iconComponentArray?.map((icon, idx) => {
          return (
            <CardActionableButton
              key={idx}
              handleFunction={icon?.onClick}
              icon={icon?.icon}
              isDisabled={icon?.isDisabled}
              title={icon?.title}
              bgColor={icon?.bgColor}
              imgColor={icon?.imgColor}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ListTextWithIcon;
